import React from 'react';
import { FaFilterCircleXmark } from 'react-icons/fa6';

import { RsFilter } from './RsFilter';
import { SearchAutocomplete, SearchAutocompleteItem } from './SearchAutocomplete';

export interface FiltersValue {
	items: SearchAutocompleteItem[];
	rs: string[];
}

export interface FiltersProps {
	value: FiltersValue;
	onChange(value: FiltersValue): void;
	rightSlot?: React.ReactNode;
}

export function Filters({ value, onChange, rightSlot }: FiltersProps) {
	const isSearchActive = value.items.length > 0;
	const isRsActive = value.rs.length > 0;
	const hasActiveFilters = isSearchActive || isRsActive;

	return (
		<div className='flex flex-wrap items-start gap-4 pb-4'>
			<div className='w-full sm:w-96'>
				<SearchAutocomplete
					selectedItems={value.items}
					disabled={isRsActive}
					onChange={(items) => onChange({ items, rs: [] })}
				/>
			</div>

			<div>
				<RsFilter selectedRs={value.rs} disabled={isSearchActive} onChange={(rs) => onChange({ items: [], rs })} />
			</div>

			<div className='flex flex-shrink-0 flex-col ml-auto'>
				<span className='block mb-1 h-[14px] leading-tight' aria-hidden='true' />
				<div className='flex items-center gap-3'>
					{rightSlot}
					<button
						type='button'
						className='flex items-center gap-1.5 h-8 px-3 rounded border border-cPurple-400 bg-white text-sm font-semibold text-cPurple-600 shadow-sm tracking-wide transition-colors hover:bg-cPurple-600 hover:border-cPurple-600 hover:text-white disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-cPurple-400 disabled:hover:text-cPurple-600'
						disabled={!hasActiveFilters}
						onClick={() => onChange({ items: [], rs: [] })}
					>
						Zrušit filtry
						<FaFilterCircleXmark className='w-3 h-3 flex-shrink-0' />
					</button>
				</div>
			</div>
		</div>
	);
}
